<template>
    <div class="page">
        <el-tabs  :tab-position="tabPosition" style="height: 100%;overflow: auto" v-model='tabs'>
            <el-tab-pane label="基本信息" name="first">
                <el-form :model="mallHotel" ref="mallHotelForm" style='padding-left: 30px;' :rules="rules" label-width="80px" size="mini" :inline="true">
                    <el-form-item label="酒店名称" prop="hotelName">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.hotelName'></el-input>
                    </el-form-item>
                    <el-form-item label="酒店品牌" prop="brandId">
                        <GridSelect
                            style="width: 200px"
                            title="选择品牌"
                            labelName="brandName"
                            labelValue="id"
                            :value="mallHotel.brandId"
                            :limit="1"
                            size="small"
                            placeholder="请选择品牌"
                            @getValue="getValue"
                            :columns="BRAND_code"
                            :searchs="BRAND_search"
                            dataListUrl="/mall/hotelbrand/findList"
                            entityBeanName="mallHotelBrand"
                            queryEntityUrl="/mall/hotelbrand/get"
                        >
                        </GridSelect>
                    </el-form-item>
                    <el-form-item label="酒店位置" prop="hotelAddress">
                        <location
                            style="width: 200px;"
                            :areaTreeDate="areaTreeDate"
                            :mallHotel="mallHotel"
                            @location="location"
                        ></location>
                    </el-form-item>
                    <el-form-item label="酒店坐标" prop="hotelPosition">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.hotelPosition'></el-input>
                    </el-form-item>
                    <el-form-item label="酒店经度" prop="longitude">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.longitude'></el-input>
                    </el-form-item>
                    <el-form-item label="酒店纬度" prop="latitude">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.latitude'></el-input>
                    </el-form-item>
                    <el-form-item label="省" prop="provinceId">
                        <el-select
                            placeholder="请选择省"
                            @change="clearSubitem('province')"
                            clearable
                            style="width: 200px"
                            size="small"
                            v-model="mallHotel.provinceId"
                        >
                            <el-option
                                v-for='(item,index) in provinceArry'
                                :key='index'
                                :label="item.areaName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="市" prop="cityId">
                        <el-select
                            placeholder="请选择市"
                            @change="clearSubitem('city')"
                            clearable
                            style="width: 200px"
                            size="small"
                            v-model="mallHotel.cityId"
                        >
                            <el-option
                                v-for='(item,index) in cityArry'
                                :key='index'
                                :label="item.areaName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区" prop="areaId">
                        <el-select
                            placeholder="请选择区"
                            clearable
                            style="width: 200px"
                            size="small"
                            v-model="mallHotel.areaId"
                        >
                            <el-option
                                v-for='(item,index) in areaArry'
                                :key='index'
                                :label="item.areaName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="酒店标签" prop="hotelTag">
                        <tag
                            style="width: 200px"
                            :value="mallHotel.hotelTag"
                            @getTagValue="getTagValue"
                        ></tag>
                    </el-form-item>
                    <el-form-item label="综合评分" prop="starNumber">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.starNumber'></el-input>
                    </el-form-item>
                    <el-form-item label="总评论数" prop="commentNumber">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.commentNumber'></el-input>
                    </el-form-item>
                    <el-form-item label="是否精选" prop="isSelected">
                        <el-select
                            placeholder="请选择是否精选"
                            clearable
                            style="width: 200px"
                            size="small"
                            v-model="mallHotel.isSelected"
                        >
                            <el-option
                                v-for='(item,index) in yesNoEnumList'
                                :key='index'
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contactPerson">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.contactPerson'></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="contactPhone">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.contactPhone'></el-input>
                    </el-form-item>
                    <el-form-item
                        label="店铺管理"
                        prop="userId"
                    >
                        <GridSelectU
                            style="width: 200px"
                            title="选择用户"
                            labelName="userName"
                            labelValue="id"
                            :value="mallHotel.userId"
                            :limit="1"
                            size="small"
                            placeholder="请选择用户"
                            @getValue="getValueUser"
                            :columns="USER_code"
                            :searchs="USER_search"
                            dataListUrl="/mpp/user/findList"
                            entityBeanName="mppUser"
                            queryEntityUrl="/mpp/user/get"
                        >
                        </GridSelectU>
                    </el-form-item>
                    <el-form-item label="最晚退订时间" prop="canCancelTime">
                        <el-time-picker
                            style="width: 200px"
                            size="small"
                            format='HH:mm:ss'
                            value-format='HH:mm:ss'
                            v-model="mallHotel.canCancelTime"
                            placeholder="请选择可取消时间">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="离店时间" prop="checkoutTime">
                        <el-time-picker
                            style="width: 200px"
                            size="small"
                            format='HH:mm:ss'
                            value-format='HH:mm:ss'
                            v-model="mallHotel.checkoutTime"
                            placeholder="请选择离店时间">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="最低价格" prop="minPrice">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.minPrice'></el-input>
                    </el-form-item>
                    <el-form-item label="最高价格" prop="maxPrice">
                        <el-input style="width: 200px" size="small" v-model='mallHotel.maxPrice'></el-input>
                    </el-form-item>
                    <el-form-item label="酒店logo" prop="hotelLogo" class="logo">
                        <el-upload
                            style="width: 200px"
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :http-request="uploadAvatar"
                        >
                            <img v-if="mallHotel.hotelLogo" :src="mallHotel.hotelLogo" class="avatar" size="small" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane name="second" label="酒店图片" >
                <el-form :model="mallHotel" ref="mallHotelForm1" style='padding-left: 30px;' :rules="rules" label-width="80px" size="mini" :inline="true">
                    <el-form-item label="酒店banner" prop="productAlbum">
                        <el-upload
                            :headers="header"
                            class="uploadAlbum"
                            :action="action"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="handleSuccess"
                            :before-upload="beforeAvatarUpload"
                            list-type="picture"
                            accept="jpg,jpeg,png,JPG,JPEG,PNG"
                            :limit="10"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <div class="bottm-btn">
            <el-button style="margin-left: 30px" type="primary" :disabled='tabs=="first"' @click="lastStep">上一步</el-button>
            <el-button style="margin-left: 30px" type="primary" :disabled='tabs=="second"' @click="nextStep">下一步</el-button>

            <el-button style="margin-left: 30px" type="primary" @click="submitForm">确认添加</el-button>
        </div>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import Location from '@/components/location/index.vue';
import Tag from '@/components/tag/tag.vue'
import GridSelectU from '@/components/gridselect';
import GridSelect from '@/components/gridselect/brand.vue';
import { get, post, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant.js';
import { BRAND, BRAND_SEARCH } from '@/utils/constant';

    export default {
        components: {
            GridSelect,
            GridSelectU,
            Location,
            Tag
        },
        data() {
            return {
                USER_code: USER,
                USER_search: USER_SEARCH,
                BRAND_code: BRAND,
                BRAND_search: BRAND_SEARCH,
                tabs:'first',
                areaTreeDate: [],
                yesNoEnumList: [],

                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                fileList: [],
                temporaryList: [],
                albumList: '',

                tabPosition: 'left',
                mapDialog: false,
                mallHotel: {
                    hotelName: '', //酒店名称
                    hotelLogo: '', //酒店logo
                    hotelBanner: '', //酒店banner
                    brandId: '', //品牌ID
                    provinceId: '', //省
                    cityId: '', //市
                    areaId: '', //区
                    hotelAddress: '', //详细地址
                    hotelPosition: '', //定位
                    longitude: '', //经度
                    latitude: '', //纬度
                    hotelTag: null, //标签
                    starNumber: '', //综合评分
                    commentNumber: '', //总评论数
                    isSelected: '', //是否精选
                    contactPerson: '', //联系人
                    contactPhone: '', //联系电话
                    remarks: '', //备注
                    paymentCode: '', //收款码
                    userId: '', //店铺管理
                    status: 2, //核审状态
                    refuseReason: '', //拒绝原因
                    canCancelTime: '', //可取消时间
                    checkoutTime: '', //结账时间
                    minPrice: '', //最低价格
                    maxPrice: '', //最高价格
                },
                rules: {
                    hotelName: [{ required: true, message: '酒店名称不能为空', trigger: 'blur' }],
                    hotelLogo: [{ required: true, message: '酒店logo不能为空', trigger: 'blur' }],
                    hotelBanner: [{ required: true, message: '酒店banner不能为空', trigger: 'blur' }],
                    brandId: [{ required: true, message: '品牌ID不能为空', trigger: 'blur' }],
                    provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                    cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                    areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                    hotelAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                    hotelPosition: [{ required: true, message: '定位不能为空', trigger: 'blur' }],
                    longitude: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
                    latitude: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
                    hotelTag: [{ required: true, message: '标签不能为空', trigger: 'blur' }],
                    starNumber: [{ required: true, message: '综合评分不能为空', trigger: 'blur' }],
                    commentNumber: [{ required: true, message: '总评论数不能为空', trigger: 'blur' }],
                    isSelected: [{ required: true, message: '是否精选不能为空', trigger: 'blur' }],
                    contactPerson: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                    contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                    remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                    paymentCode: [{ required: true, message: '收款码不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
                    canCancelTime: [{ required: true, message: '可取消时间不能为空', trigger: 'blur' }],
                    checkoutTime: [{ required: true, message: '结账时间不能为空', trigger: 'blur' }],
                    minPrice: [{ required: true, message: '最低价格不能为空', trigger: 'blur' }],
                    maxPrice: [{ required: true, message: '最高价格不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getTreeData();
            this.getYesNoEnum();
        },
        computed:{
            provinceArry(){
                return this.areaTreeDate
            },
            cityArry(){
                if(!this.provinceArry){
                    return []
                } else {
                    for (let i = 0; i < this.provinceArry.length; i++) {
                        if(this.provinceArry[i].id == this.mallHotel.provinceId){
                            return this.provinceArry[i].children
                        } else if (this.mallHotel.provinceId == "") {
                            return []
                        }
                    }
                }
            },
            areaArry(){
                if(!this.cityArry){
                    return []
                } else {
                    for (let i = 0; i < this.cityArry.length; i++) {
                        if(this.cityArry[i].id == this.mallHotel.cityId){
                            return this.cityArry[i].children
                        }
                    }
                }
            },
        },
        methods:{
            submitForm() {
                this.mallHotel.hotelBanner = this.albumList

                this.$refs.mallHotelForm.validate((valid) => {
                    if (valid) {
                        this.$refs.mallHotelForm1.validate((valid1) => {
                            if(valid1){
                                console.log('submit');
                                post(`/mall/hotel/add`,{ ...this.mallHotel }).then((res) => {
                                    if (res.success && res.code == 200) {
                                        this.$message({
                                            message: res.msg,
                                            type: 'success',
                                            duration: 2000,
                                        });
                                        this.$router.push('/Hotel/MallHotel');
                                        this.resetMallHotel();
                                    } else {
                                        this.$message({
                                            message: res.msg,
                                            type: 'error',
                                            duration: 2000,
                                        });
                                    }
                                });
                            }
                        })
                    }
                });
            },
            //上传缩略图
            uploadAvatar(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.mallHotel.hotelLogo = res.url;
                    }
                });
            },
            handleRemove(file, fileList) {
                for (let i = 0; i < this.temporaryList.length; i++) {
                    if (file.response.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                }
                this.albumList = this.temporaryList.join('|');
            },
            handleSuccess(response, file, fileList) {
                this.temporaryList.push(file.response.url);
                this.albumList = this.temporaryList.join('|');
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 50MB!');
                }
                return isLt2M;
            },
            getValue(value) {
                this.mallHotel.brandId = value;
            },
            getValueUser(value){
                this.mallHotel.userId = value
            },
            getTagValue(value){
                this.mallHotel.hotelTag = value
            },
            getTreeData(){
                get('/mpp/area/treeData').then((res)=>{
                    if(res.success){
                        this.areaTreeDate = res.treeData[0].children
                    }
                })
            },
            location(location){
               console.log('location',location)
                this.mallHotel.hotelPosition = `${location.lng},${location.lat}`
                this.mallHotel.longitude = location.lng
                this.mallHotel.latitude = location.lat
                this.mallHotel.hotelAddress = location.address
                this.mallHotel.provinceId = location.province
                this.mallHotel.cityId = location.city
                this.mallHotel.areaId = location.area
            },
            resetMallHotel(){
                this.tabs = "first"

                this.mallHotel = {
                    hotelName: '', //酒店名称
                    hotelLogo: '', //酒店logo
                    hotelBanner: '', //酒店banner
                    brandId: '', //品牌ID
                    provinceId: '', //省
                    cityId: '', //市
                    areaId: '', //区
                    hotelAddress: '', //详细地址
                    hotelPosition: '', //定位
                    longitude: '', //经度
                    latitude: '', //纬度
                    hotelTag: null, //标签
                    starNumber: '', //综合评分
                    commentNumber: '', //总评论数
                    isSelected: '', //是否精选
                    contactPerson: '', //联系人
                    contactPhone: '', //联系电话
                    remarks: '', //备注
                    paymentCode: '', //收款码
                    userId: '', //店铺管理
                    status: 2, //核审状态
                    refuseReason: '', //拒绝原因
                    canCancelTime: '', //可取消时间
                    checkoutTime: '', //结账时间
                    minPrice: '', //最低价格
                    maxPrice: '', //最高价格
                }
            },
            // 获取yes_no枚举
            getYesNoEnum(){
                get('/mpp/utils/getEnum',{
                    enumType: 'yes_no',
                }).then((res)=>{
                    if(res.success){
                        this.yesNoEnumList = res.enumList
                    }
                })
            },
            //上一步
            lastStep(){
                switch (this.tabs) {
                    case 'second': this.tabs = 'first';
                        break;
                }
            },
            //下一步
            nextStep(){
                switch (this.tabs) {
                    case 'first': this.tabs = 'second';
                        break;
                }
            },
            // 省市区清除器
            clearSubitem(id){
                if (id == 'province'){
                    this.mallHotel.cityId = ""
                    this.mallHotel.areaId = ""
                } else if (id == 'city') {
                    this.mallHotel.areaId = ""
                }
            },

        }
    };
</script>
<style scoped lang="scss">
    .page{
        width: 100%;
        height: 100%;
        background-color: #fff;
        padding: 30px;
    }
    .bottm-btn{
        margin-top: 20px;
        padding-left: 100px;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
    .avatar {
        width: 200px;
        height: 200px;
        display: block;
    }

    .logo{
        ::v-deep .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            width: 200px;
            height: 200px;
        }
    }


</style>